import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import type { NegociationId, Timestamp } from '@/store/pretrade/api/types.ts';

export type CreateNegociationParameters = Timestamp;
export type CreateQuoteParameters = { negociationId: NegociationId; creationTimestamp: Timestamp };
export type EndNegociationParameters = {
  negociationId: NegociationId;
  terminationTimestamp: Timestamp;
  dealDone: boolean;
};

export const createNegociation = (builder: WebapiEndpointBuilder) => {
  return builder.mutation<NegociationId, CreateNegociationParameters>({
    query: (creationTimestamp) => ({
      url: '/Pretrade/Registrations',
      method: 'POST',
      body: {
        timestamp: new Date(creationTimestamp).toISOString(),
      },
    }),
  });
};

export const createQuote = (builder: WebapiEndpointBuilder) => {
  return builder.mutation<void, CreateQuoteParameters>({
    query: ({ negociationId, creationTimestamp }) => ({
      url: `/Pretrade/Registrations/${negociationId}`,
      method: 'PUT',
      body: {
        timestamp: new Date(creationTimestamp).toISOString(),
      },
    }),
  });
};

export const endNegociation = (builder: WebapiEndpointBuilder) => {
  return builder.mutation<void, EndNegociationParameters>({
    query: ({ negociationId, terminationTimestamp, dealDone }) => ({
      url: `/Pretrade/Registrations/${negociationId}`,
      method: 'PUT',
      body: {
        dealDone,
        timestamp: new Date(terminationTimestamp).toISOString(),
      },
    }),
  });
};
